export enum TOOLTIP_THEME {
    DEFAULT = 'default',
    ERROR = 'error',
    WARNING = 'warning',
    LIGHT_ROUNDED = 'light-rounded',
}
